import React from "react";
import { Link } from "react-router-dom";
import { Toaster } from "../components/ui/sonner";
import Logo from "./Logo";

const TOAST_OPTIONS = {
    style: {
        background: "var(--vl-surface)",
        border: "1px solid var(--vl-border)",
        color: "var(--vl-text)",
        borderRadius: 0,
    },
};

export default function AdminLayout({ children }) {
    return (
        <>
            <header
                className="sticky top-0 z-30"
                style={{
                    background: "rgba(10,10,11,0.85)",
                    backdropFilter: "blur(18px)",
                    borderBottom: "1px solid var(--vl-border)",
                }}
            >
                <div className="max-w-[1440px] mx-auto px-6 md:px-12 h-[60px] flex items-center justify-between">
                    <Link
                        to="/admin"
                        className="inline-flex items-center gap-4"
                        data-testid="admin-brand"
                    >
                        <Logo size="xs" variant="plate" testId="admin-logo" />
                        <span
                            className="overline"
                            style={{ color: "var(--vl-rose)" }}
                        >
                            Atelier Console
                        </span>
                    </Link>
                    <Link
                        to="/"
                        className="overline hover:text-[var(--vl-rose)]"
                        style={{ color: "var(--vl-text)" }}
                    >
                        View storefront →
                    </Link>
                </div>
            </header>
            <main>{children}</main>
            <Toaster
                theme="dark"
                position="bottom-center"
                toastOptions={TOAST_OPTIONS}
            />
        </>
    );
}
